import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { t as typy } from 'typy'

import Highlights from 'src/components/Modules/Highlights'
import SEO from 'src/components/SEO/SEO'
import BrandHero from 'src/components/Brand/BrandHero'
import ProductCarousel from 'src/components/Modules/ProductCarousel'
import ProductList from 'src/components/Modules/ProductList'
import SeoText from 'src/components/Modules/SeoText'
import { getSeoData } from 'src/helpers/getSeoData'

type Props = {
  pageContext: any
  preview?: any
  brand: any
}

@inject('preview', 'brand')
@observer
class Brand extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
    const { brand, pageContext } = this.props

    if (brand) {
      brand.setBrandHeader(pageContext.page.centraId, true)
    }
  }

  render(): JSX.Element {
    let { pageContext, preview } = this.props
    let { page } = pageContext

    if (preview && preview.previewData) {
      const previewBrandpage = preview.getCurrentPageContext(
        pageContext.page.contentType,
        pageContext.page.locale,
        pageContext.page.slug,
        pageContext.page.brand
      )
      if (previewBrandpage) {
        page = previewBrandpage
      }
    }

    const { content, hero, centraId, seoData } = page

    const generatedSEO = getSeoData(seoData)
    if (!generatedSEO.seoTitle) {
      generatedSEO.seoTitle = page.brand
    }

    return (
      <div>
        <SEO {...generatedSEO} />
        <BrandHero intersect critical={true} highlight={hero} />
        {content &&
          content.length > 0 &&
          content.map((section: any, index: number) => {
            switch (typy(section, 'sys.contentType.sys.id').safeObject) {
              case 'highlights':
                return (
                  <Highlights
                    key={'content' + index}
                    highlights={typy(section, 'fields.highlights').safeObject}
                  />
                )
              case 'productCarousel':
                return (
                  <ProductCarousel
                    brand={centraId}
                    key={'content' + index}
                    fields={typy(section, 'fields').safeObject}
                  />
                )
              case 'productList':
                return (
                  <ProductList
                    brand={centraId}
                    key={'content' + index}
                    fields={typy(section, 'fields').safeObject}
                  />
                )
              case 'fullWidthSplash':
                return (
                  <BrandHero
                    splash
                    key={'content' + index}
                    highlight={typy(section, 'fields.content').safeObject}
                  />
                )
              case 'seoText':
                return (
                  <SeoText
                    key={'content' + index}
                    text={typy(section, 'fields.text').safeObject}
                  />
                )
              default:
                return null
            }
          })}
      </div>
    )
  }
}

export default Brand
